import {
  Button,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalOverlay,
  ModalProps,
  ModalCloseButton,
  useDisclosure,
} from '@everlywell/ui-kit';
import { formatHashId, useMDPModalContext } from 'contexts/MDPModal';
import { navigate } from 'gatsby';
import React from 'react';
import { isFullUrl } from 'utils/helpers';
import { replaceRedirectionLinkRoot } from 'utils/helpers/replaceRedirectionLinkRoot';

export type CustomModalProps = {
  isModalOpen: boolean;
  handleClose: () => void;
  id: string;
  heading?: string;
  content?: React.ReactNode;
  cta?: {
    label?: string;
    url?: string;
  };
  size?: ModalProps['size'];
};

const CustomModal = ({
  isModalOpen,
  handleClose,
  id,
  heading,
  content,
  cta,
  size,
}: CustomModalProps) => {
  const { openHandler: openScreenerModal, hashId } = useMDPModalContext();
  const { isOpen, onClose } = useDisclosure({
    isOpen: isModalOpen,
    onClose: handleClose,
  });

  const handleOnClick = () => {
    const url = cta?.url;
    const hash = formatHashId(url);
    if (hash === hashId) {
      onClose();
      openScreenerModal(true);
    } else if (isFullUrl(url)) {
      navigate(url || '');
    } else {
      navigate(replaceRedirectionLinkRoot(url || ''));
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} id={id} size={size ?? 'xl'}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{heading}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>{content}</ModalBody>
        {cta && (
          <ModalFooter>
            <Button onClick={handleOnClick} role="button" width="100%">
              {cta?.label}
            </Button>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default CustomModal;
